import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

import type { MachineContext } from '../ResolutionFlow.machine.types'

export async function getSelfTroubleshootingArticles({
  diagnosisV2CustomerIssues,
  orderlineId,
}: MachineContext) {
  const $httpFetch = useHttpFetch()
  const payload = await $httpFetch(
    '/help-center/api/v1/auth/articles/self-troubleshooting',
    {
      query: {
        orderlineId,
        customerIssues: diagnosisV2CustomerIssues.join(';'),
      },
    },
  )

  return payload
}
